
import {
  Component, Prop,
  Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class ProjectItemPlaceholder extends Mixins(OperationComponentMixin) {
  @Prop(String) readonly taskName!: string;

  get tooltipText(): string | null {
    switch (this.taskName) {
      case 'M':
        return 'Modifica le informazioni sul materiale e la spedizione (in comune)';

      case 'I':
        return 'Modifica le informazioni sull\'installazione (in comune)';

      default:
        break;
    }

    return null;
  }

  get columnClass(): string {
    switch (this.taskName) {
      case 'M':
        if (this.operationChild?.flatTasks.includes('M=c')) return 'completed';
        if (this.operationChild?.flatTasks.includes('M=e')) return 'error';
        break;

      case 'I':
        if (this.operationChild?.flatTasks.includes('I=c')) return 'completed';
        if (this.operationChild?.flatTasks.includes('I=e')) return 'error';
        // if (this.installationCompleted) return 'completed';
        // if (this.installationDateConfirm) return 'selected';
        break;

      case 'R':
        if (this.operationChild?.flatTasks.includes('R=c')) return 'completed';
        if (this.operationChild?.flatTasks.includes('R=e')) return 'error';
        break;

      default:
        break;
    }
    return '';
  }

  onEdit() {
    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
